/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  rebateProgram: [],
  rebateProgramName: {},
  errorMsgDisputeAct: [],
  drugData: [],
  open: true,
  closed: false,
  selectedNDC: [],
  ndcLeftTableData: [],
  labelerSelectedRow: [],
  selectedSearchType: 'Name',
  selectByValue: 'Manufacturer',
  selectedDisputeValue: 'ALL',
  checkedValue: false,
  selectedPlanType: '',
  gridMFG: [],
  gridNDC: [],
  selectedRowIndexValue: [],
  exportAllData: [],

  mfgCount: 0,
  allManufacturer: [],
  manufactureWithIds: [],
  disputeCodeOption: [],
  displayObj: {
    rebateProgramName: {},
    open: true,
    closed: false,
    allManufacturer: [],
    manufactureWithIds: [],
    gridMFG: [],
    gridNDC: [],
    drugData: [],
    disputeCodeOption: [],
    selectByValue: 'Manufacturer',
    selectedNDC: [],
    ndcLeftTableData: [],
    labelerSelectedRow: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_ACT:
      return { ...state, performDisputeResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_ACT:
      return { ...state, disputeResolutionDetailObj: action.detailScrData };
    case actionTypes.SEARCH_MFG_DISP_ACTIVITY:
      return { ...state, mfgListSelected: action.payload };
    case actionTypes.GET_ERROR_MSG_DISPUTE_ACTIVITY:
      return { ...state, errorMsgDisputeAct: action.payload };
    case actionTypes.GET_ERROR_MSG_NDC_DETAILS:
      return { ...state, errorMsgNdcDetails: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_ACT:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_ACT:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_ACT:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.MANUFACTURER_GRID_ACT:
      return { ...state, manufacturerList: action.manufacturerList };
    case actionTypes.SELECTED_DISPUTE_CODE:
      return { ...state, selectedCode: action.payload };
    case actionTypes.GET_ALL_LABELER_ACT:
      return { ...state, labelerList: action.payload };
    case actionTypes.DISPLAY_DISPUTE_CODE:
      return { ...state, disputeCodeOption: action.payload };
    case actionTypes.GET_MANUFACTURER_NAME_ACT:
      return { ...state, allManufacturer: action.allManufacturer };
    case actionTypes.GET_MANUFACTURER_ID_ACT:
      return { ...state, manufactureWithIds: action.manufactureWithIds };
    case actionTypes.GRID_MFG_ACT:
      let displayObj = {
        ...state.displayObj,
        gridMFG: action.payload,
      };
      return { ...state, gridMFG: action.payload, displayObj };

    case actionTypes.GRID_NDC_ACT:
      let displayObj1 = {
        ...state.displayObj,
        gridNDC: action.payload,
      };
      return {
        ...state,
        gridNDC: action.payload,
        displayObj: displayObj1,
      };
    case actionTypes.SET_DISPLAY_OBJ_ACTIVITY:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.SELECT_OPTION:
      return { ...state, ...action.payload };
    case actionTypes.SET_MFG_COUNT:
      return { ...state, mfgCount: action.payload };

    case actionTypes.GET_DRUG_DATA_ACT:
      return {
        ...state,

        drugData: action.payload.selectedNDC,
        selectedNDC: action.payload.selectedNDC,
        ndcLeftTableData: action.payload.ndcLeftTableData,
        labelerSelectedRow: action.payload.labelerSelectedRow,
      };
    case actionTypes.SET_STATUS_ACT:
      return { ...state, ...action.payload };
    case actionTypes.REFRESH_DISPUTE_ACTIVITY:
      return {
        ...state,
        performDisputeResolutionObj: {},
        planType: [],
        rebateProgram: [],
        rebateProgramName: {},
        errorMsgDisputeAct: [],
        drugData: [],
        open: true,
        closed: false,
        selectedNDC: [],
        ndcLeftTableData: [],
        labelerSelectedRow: [],
        selectedSearchType: 'Name',
        selectByValue: 'Manufacturer',
        selectedDisputeValue: 'ALL',
        checkedValue: false,
        selectedPlanType: '',
        gridMFG: [],
        gridNDC: [],
        selectedRowIndexValue: [],
        exportAllData: [],

        mfgCount: 0,
        allManufacturer: [],
        manufactureWithIds: [],
        disputeCodeOption: [],
      };
    case actionTypes.REFRESH_DISPUTE_ACTIVITY_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    case actionTypes.SET_EXPORT_ALL_DISPUTE_ACTIVITY:
      const data =
        action.payload?.key == undefined
          ? {}
          : {
              [action.payload.key]: action.payload.data,
              ...state.exportAllData,
            };
      return {
        ...state,
        exportAllData: data,
      };
    case actionTypes.SET_PAGINATION_INDEX_DISPUTE_ACTIVITY:
      return {
        ...state,
        displayObj: {
          ...state.displayObj,
          countValue: action.payload,
        },
      };
    default:
      return state;
  }
};
export default reducer;
